import { ConversationPanel } from "@/features/enterprises/components/conversations/ConversationPanel";

/**
 * Wewnętrzne rozmowy przy umowie ramowej — dokładnie te same dwa kanały co przy
 * przedsięwzięciu (ProjectConversations), tylko przypięte do umowy:
 *
 *  • dyrektorska — dyrektorzy i CEO,
 *  • zarządu — wyłącznie CEO.
 *
 * Panele są te same co w przedsięwzięciach (`base="agreements"` przełącza adresy
 * API), więc pisanie, odpowiedzi, @wzmianki i załączniki działają identycznie i nie
 * rozjadą się przy kolejnej zmianie tamtych.
 *
 * Podwykonawca nie widzi tu niczego — backend odcina konta zewnętrzne od obu kanałów
 * także przy WŁASNEJ umowie (apps.contractors.agreement_conversations).
 */
export function AgreementConversations({
  agreementId,
  currentUserId,
  isDirector,
  isCeo,
}: {
  agreementId: string;
  currentUserId: string;
  isDirector: boolean;
  isCeo: boolean;
}) {
  if (!isDirector && !isCeo) return null;

  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Konwersacje
      </h2>
      <div className={`grid gap-4 ${isCeo ? "grid-cols-1 lg:grid-cols-2" : "grid-cols-1"}`}>
        <ConversationPanel
          key={`${agreementId}-director`}
          base="agreements"
          projectId={agreementId}
          conversationType="director"
          title="Konwersacja dyrektorska"
          currentUserId={currentUserId}
          isCeo={isCeo}
        />

        {isCeo && (
          <ConversationPanel
            key={`${agreementId}-board`}
            base="agreements"
            projectId={agreementId}
            conversationType="board"
            title="Konwersacja zarządu"
            currentUserId={currentUserId}
            isCeo={isCeo}
          />
        )}
      </div>
    </div>
  );
}
